export enum QUERY_PARAMS {
	GLOBAL = 'global',
	SELECTED_TEAM_ID = 'selectedTeamId',
	AVP_QUERY_LOG = 'querylog',
}

export const SPOTLIGHT_NAMES = {
	sidebarReportItems: 'eoc-reports-sidenav',
};

export const IFHR_DASHBOARD_SLUG = 'embed_ops_infrastructure_health_report';

export const AVP_DASHBOARD_IDS = [IFHR_DASHBOARD_SLUG];

export const ENABLED_PRODUCTS = {
	AVP: 'AVP',
	LOOKER: 'LOOKER',
};

export const EMBED_TOKEN_EXPIRY_BUFFER = 30000;
